<template>
  <div class="p-help g-page">
    <VGrid>
      <div slot="gridItem" type="8" subtype="relative-sticky-column">
        <VForm :onSubmit="searchSubmit">
          <div slot="row">
            <VInput
              type="text"
              :placeholder="$t('help.searchPlaceholder')"
              :icon="true"
              v-model="searchQuery"
              data-ec="help_page"
              data-et="search_input">
              <SearchIcon />
            </VInput>
          </div>
        </VForm>
        <br />
        <h3>{{ $t('help.topHelpArticles') }}</h3>
        <div v-for="(item, index) in topArticles" class="p-help__article-link" :key="index">
          &gt; <a :href="item.link" v-html="item.title.rendered" target="_blank" data-ec="help_page" data-et="help_article_link" />
        </div>
        <br />
        <h3>{{ $t('help.dedicatedSupportSite') }}</h3>
        <p>
         {{ $t('help.browseLibraryMessage') }} <a href="https://signable.help" target="_blank" data-ec="help_page" data-et="help_site_link">https://signable.help</a>.
        </p>
        <h3>{{ $t('help.scheduleATime') }}</h3>
        <p> <a target="_blank" href="https://calendly.com/teamsignable/signable-free-trial">{{ $t('help.chooseATime.a') }}</a> {{ $t('help.chooseATime.b') }}</p>
      </div>
      <div slot="gridItem" type="4">
        <VStickyColumn
          relativeElementSelector=".o-grid__item--relative-sticky-column"
          pageClass=".p-help">
          <div class="g-sidebar__container">
            <h3 class="g-sidebar__container__header">
              <InfoCircleIcon
                height="22"
                width="22"
              />
              <span>{{ $t('functional.whatIsThis') }}</span>
            </h3>
            <p>
              {{ $t('help.whatIsThisMessage') }}
            </p>
          </div>
          <div class="g-sidebar__container">
            <h3 class="g-sidebar__container__header">
              <PhoneIcon
                height="22"
                width="22"
              />
              <span>{{ $t('help.contactSupport') }}</span>
            </h3>
            <a
              href="tel:+448006126263"
              class="p-help__phone-number"
              data-test="help-phone-number"
              data-ec="help_page"
              data-et="phone_number">
              0800 612 6263
            </a>
            <p>
              <b><span> {{ getOpenTime() | formatDate('time') }} </span></b>
              - <b><span> {{ getCloseTime() | formatDate('time') }} </span></b>&nbsp;
              <span> {{ getCloseTime() | formatDate('timezone') }} </span>
              <br />{{ $t('help.mondayToFriday') }}
            </p>
            <a href="mailto:help@signable.co.uk">help@signable.co.uk</a>
          </div>
          <div class="g-sidebar__container">
            <h3 class="g-sidebar__container__header">
              <CommentsIcon
                height="22"
                width="22"
              />
              <span>{{ $t('help.liveChat') }}</span>
            </h3>
            <p>{{ $t('help.liveChatMessage.a') }}</p>
            <p>{{ $t('help.liveChatMessage.b') }}</p>
          </div>
        </VStickyColumn>
      </div>
    </VGrid>
  </div>
</template>

<script>
import axios from 'axios';
import Moment from 'moment';
import 'moment-timezone';

import VInput from '@/components/deprecated/atoms/Input.vue';
import VStickyColumn from '@/components/deprecated/molecules/StickyColumn.vue';
import VForm from '@/components/deprecated/organisms/Form.vue';
import VGrid from '@/components/deprecated/organisms/Grid.vue';
import { CommentsIcon, InfoCircleIcon, PhoneIcon, SearchIcon } from '@/components/icons/fontIcons';

export default {
  name: 'HelpView',
  components: {
    VInput,
    VStickyColumn,
    VForm,
    VGrid,
    CommentsIcon,
    InfoCircleIcon,
    PhoneIcon,
    SearchIcon,
  },
  data() {
    return {
      topArticles: null,
      searchQuery: '',
    };
  },
  mounted() {
    return axios({
      method: 'get',
      url: 'https://signable.help/wp-json/wp/v2/posts?filter[cat]=8',
    }).then((results) => {
      this.topArticles = results.data;
    });
  },
  methods: {
    searchSubmit() {
      window.open(`https://signable.help/?s=${this.searchQuery}`, '_blank');
    },
    getOpenTime() {
      return Moment.tz('0800', 'HHmm', 'Europe/London').unix();
    },
    getCloseTime() {
      return Moment.tz('1700', 'HHmm', 'Europe/London').unix();
    },
  },
};
</script>

<style scoped>
.p-help__article-link {
  margin-bottom: 2px;
}

.p-help__phone-number {
  font-size: var(--font-size-large);
  text-decoration: none;
  display: block;
  margin-bottom: var(--spacing-base);
}

.p-help h3 {
  margin: 15px 0;
}
</style>
